module.exports = __webpack_public_path__ + "static/media/swingSubImg2.14931a43.png";